<!-- eslint-disable vue/valid-v-for -->
<template>
	<div>
		<b-row>
			<b-col cols="12">
				<h3>Proposed Repayment Sources</h3>
			</b-col>
		</b-row>
		<b-card no-body v-loading="is_loading">
			<div class="table-listings">
				<el-table ref="proposedRepaymentTable" style="width: 100%" size="small" show-summary
					:data="tableData" :header-cell-class-name="'text-13px'" :summary-method="getSummaries">
					<!-- CHECKBOX -->
					<!-- <el-table-column v-if=" _gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55" fixed></el-table-column> -->
					<el-table-column type="index" width="50" class-name="text-center font-weight-bold"></el-table-column>

					<el-table-column label="Option" min-width="130" prop="proposed_via" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.proposed_via" :options="repaymentViaOptions" :disabled="isViewOnly" size="sm"></b-form-select>
						</template>
					</el-table-column>

					<el-table-column label="Description" min-width="180" prop="facility" sortable>
						<template slot-scope="scope">
							<b-form-input v-model="scope.row.facility" type="text" :disabled="isViewOnly" size="sm"></b-form-input>
						</template>
					</el-table-column>

					<!-- <el-table-column label="Amount" min-width="150" prop="process_amount" sortable class-name="text-right">
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.process_amount" size="sm" 
								:disabled="isViewOnly" :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column> -->

					<el-table-column label="Eligible Amount" min-width="150" prop="balance_amaount" sortable>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.balance_amaount" size="sm"
								:disabled="isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column min-width="30" fixed="right" v-if="!isViewOnly">
						<template slot-scope="scope">
							<el-dropdown trigger="click" style="cursor: pointer">
								<p class="el-dropdown-link mb-0 top-line">
									<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
								</p>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="removeItem(scope.row.id, scope.$index)">
										<span class="text-danger">
											<!-- Trash-Can Icon -->
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
												<path fill="#DF3030"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
											</svg>
											Delete
										</span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="text-right p-2" v-if="!isViewOnly">
				<el-button type="primary" class="mx-1" size="mini" @click="addItem" icon="el-icon-circle-plus-outline"> Add</el-button>
				<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate" icon="el-icon-circle-check">Save & Calculate</el-button>
			</div>
		</b-card>
	</div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Switch, Table, TableColumn, Button, Select, Option, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
	props: ['is-view-only'],
	components: {
		CurrencyInput,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		[Switch.name]: Switch,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	data() {
		return {
			is_loading_rows: [],
			oldTableData: [],
			tableData: [],
			tableSummary: {},
			tableColumnSkipSummary: [0, 1, 2, 5],
			formData:{
				repaymentItemsList:[],
				repayment_loan_amount:0
			},
			repaymentViaOptions: [],
			deletedItemIds:[],
		}
	},
	created() {
		this.getRepaymentViaOptions();
		this.initComponent();
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeLoanECRepaymentSrc', 'activeLoanEC', 'activeFormLoanEc']),
		is_loading(){
			return _gHlp.isLoading('fetch_repayment_items') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
		activeLoanECRepaymentSrc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent();
				}
			},
			immediate: true
		},
		tableSummary: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.callbackTableSummary(newVal);
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCommonStore, ['getDroplist']),
		...mapActions(useCustomerStore, ['getProposedRepaymentList', 'createOrUpdateProposedRepayment', 'deleteProposedRepayment', 'setFormLoanEc']),
		clearComponent(){
			this.is_loading_rows = []
			this.oldTableData = []
			this.tableData = []
			this.tableSummary = {}
			this.formData = {
				repaymentItemsList:[],
				repayment_loan_amount:0
			}
			this.deletedItemIds = []
		},
		initComponent() {
			_gHlp.setLoading('fetch_repayment_items')
			this.fetcAllRelations(this.activeLoanECRepaymentSrc)
		},
		fetcAllRelations(resp){
			this.tableData = [];
			if (!_gHlp.isEmpty(resp) && !_gHlp.isEmpty(resp.data)) {
				this.tableData = resp.data
			}
			this.setOldData()
			_gHlp.removeLoading('fetch_repayment_items')
		},
		setOldData(){
			this.oldTableData = cloneDeep(this.tableData)
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			const cbData = [];

			columns.forEach((column, index) => {
				if (index === 2) {
					sums[index] = 'Total';
					return;
				}
				if (this.tableColumnSkipSummary.includes(index)) {
					return;
				}

				const values = data.map(item => {
					return Number(item[column.property])
				});
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
					cbData[column.property] = total
				} else {
					sums[index] = '';
				}
			});

			//callback
			this.tableSummary = cbData;
			return sums;
		},
		callbackTableSummary(data, save=false) {
			this.formData.repaymentItemsList = this.tableData
			this.formData.repayment_loan_amount = !_gHlp.isEmpty(data) ? parseFloat(data.balance_amaount) : 0;
			// this.formData.repayment_loan_amount = !_gHlp.isEmpty(data) ? parseFloat(data.process_amount) : 0;
			this.setFormLoanEc(this.formData)
			this.$emit('change',save);
		},
		addItem() {
			this.tableData.push({
				id: null,
				proposed_via: '',
				facility: '',
				process_amount: '',
				charge_rate: '',
				charge_amount: '',
				balance_amaount: '',
				period:''
			})
		},
		getRepaymentViaOptions() {
			this.getDroplist('lec_proposed_repayment').then((res) => {
				this.repaymentViaOptions = res;
			});
		},
		removeItem(id, index) {
			// Check if the index is within the array bounds
			if (index >= 0 && index < this.tableData.length) {
				// Use splice to remove the item at the specified index
				this.tableData.splice(index, 1);
				if (!_gHlp.isEmpty(id)) {
					this.deletedItemIds.push(id);
				}
			}
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}

			return {
				id: item.id,
				proposed_via: item.proposed_via,
				facility: item.facility,
				process_amount: item.process_amount,
				charge_rate: item.charge_rate,
				charge_amount: item.charge_amount,
				balance_amaount: item.balance_amaount,
				period: item.period
			}
		},
		submitAndCalculate(){
			let updateItems = [];
			//DELETD ITEMS
			if(!_gHlp.isEmpty(this.deletedItemIds)){
				for(let i = 0; i < this.deletedItemIds.length; i++){
					let itmId = this.deletedItemIds[i];
					updateItems.push(this.deleteProposedRepayment(itmId))
				}
			}

			//UPDATE ITEMS
			for (let idx = 0; idx < this.tableData.length; idx++) {
				const newData = this.getParams(this.tableData[idx])	
				const oldData = this.getParams(this.oldTableData.find(itm => itm.id === newData.id));
				if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
					updateItems.push(this.createOrUpdateProposedRepayment(newData));
				}
			}
			
			if(!_gHlp.isEmpty(updateItems)){
				_gHlp.setLoading('fetch_repayment_items')
				Promise.all(updateItems)
				.then(res  => {
					this.callbackTableSummary(this.tableSummary,true)
					this.getProposedRepaymentList().then(resp => {
						this.fetcAllRelations(resp)
						this.deletedItemIds = [];
					})
					_gHlp.removeLoading('fetch_repayment_items')
				})
				.catch(e => {
					_gHlp.removeLoading('fetch_repayment_items')
				})
			}
		}
	}
}
</script>